import { render, staticRenderFns } from "./cashin.vue?vue&type=template&id=a672e732"
import script from "./cashin.vue?vue&type=script&lang=js"
export * from "./cashin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports